import Entity from './entity'

const InvoiceUpdate = new Entity('invoiceupdates')

export default InvoiceUpdate
